module.exports = __webpack_public_path__ + "img/GENIO_waiting.4f9450ca.svg";